import { gql } from '@apollo/client';

export type {
  GetMarketOptions as IGetMarketOptions,
  GetMarketOptionsVariables as IGetMarketOptionsVariables,
} from './__generated__/GetMarketOptions';

export const GET_MARKET_OPTIONS = gql`
  query GetMarketOptions($identifier: String!) {
    partnerBranchesByIdentifier(identifier: $identifier) {
      regionIdentifier
      marketDisplayName
      marketActive
    }
  }
`;
